import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoDateInputOutlined,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {MemorialNoteService} from "../../../../serverService/memorialNoteService/MemorialNoteService";
import {useEffect, useState} from "react"
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";
import {RouteHelper} from "../../../../route/RouteHelper";

export default function MemorialNoteInfo({memorialNoteId}) {

    const service = new MemorialNoteService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [userFullName, setUserFullName] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [likeCount, setLikeCount] = useState(0);
    const [editedAt, setEditedAt] = useState("");
    const [message, setMessage] = useState("");
    const [userId, setUserId] = useState("")


    useEffect(() => {
        if (typeof service !== "undefined") {
            getMemorialNoteInformationFromServer()
        }
    }, [memorialNoteId]);

    function getMemorialNoteInformationFromServer() {
        loading.show()
        service.getMemorialNoteInformation(memorialNoteId)
            .then(response => {
                setUserFullName(response.userFullName)
                setCreatedAt(response.createdAt)
                setEditedAt(response.editedAt)
                setLikeCount(response.likeCount)
                setMessage(response.message)
                setUserId(response.userId)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleShowUserInformation() {
        window.open(RouteHelper.UserInformation.globalUrl.replace(":id", userId), "_blank")
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات دلنوشته"}
                    hasSecondaryButton
                    secondaryButtonTitle={"اطلاعات کاربر"}
                    secondaryButtonOnClick={handleShowUserInformation}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"نام و نام خانوادگی نویسنده"}
                                value={userFullName}
                                setValue={setUserFullName}
                                disabled
                            />
                            <RaikoNumberInputOutlined
                                labelText={"تعداد لایک"}
                                value={likeCount}
                                setValue={setLikeCount}
                                disabled
                            />
                            <RaikoDateInputOutlined
                                labelText={"تاریخ ساخت"}
                                setValue={setCreatedAt}
                                value={convertUniversalDateToPersianDate(createdAt)}
                                disabled
                            />
                            <RaikoDateInputOutlined
                                labelText={"تاریخ آخرین ویرایش"}
                                value={convertUniversalDateToPersianDate(editedAt)}
                                setValue={setEditedAt}
                                disabled
                            />
                        </RaikoGridTwoColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"دلنوشته"}
                            value={message}
                            setValue={setMessage}
                            rows={5}
                            disabled
                        />
                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}